import { createSelector } from '@reduxjs/toolkit';

import type { AppState } from 'redux-store';

export const specialOfferSelector = (
  state: AppState,
): AppState['specialOfferPage'] => state.specialOfferPage;
export const isTimerVisibleSelector = createSelector(
  specialOfferSelector,
  specialOfferPage => specialOfferPage.isTimerVisible,
);
export const startTimerSelector = createSelector(
  specialOfferSelector,
  specialOfferPage => specialOfferPage.start,
);
